import type { MixRecipeRateUnit } from 'hooks/useMixRecipe/types';

type Params = {
    rate: number;
    rateUnit: MixRecipeRateUnit;
    totalAcres: number;
};

/**
 * Computes the total-applied string shown in the Tank Mix column.
 *
 * Rate units are per-acre (e.g. "oz/ac"), so total applied is
 * `rate * totalAcres` expressed in the rate's numerator unit
 * (e.g. "32 oz/ac" x "100 ac" = "3200 oz").
 */
export const formatTotalApplied = ({ rate, rateUnit, totalAcres }: Params): string => {
    const totalValue = rate * totalAcres;
    const [numeratorUnit] = rateUnit.split('/');

    return `${totalValue} ${numeratorUnit}`;
};
